// @ts-check

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ItemCommentsDialog from '../../components/Dialogs/ItemCommentsDialog/itemCommentsDialog';
import { jsxActions as itemCommentsDialogActions } from '../../actions/Dialogs/itemCommentsDialogActions';


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(itemCommentsDialogActions, dispatch),
  }
}

export default connect(
  
  /** @param {import('mat/js/types/PL_ReduxTypes').PL_FullState} state */
  (state) => {
    
    let sData = state.dialogs.get('itemCommentsDialog');
    
    return {
      sData: sData,
      show: sData.get('show'),
    }
  },
  mapDispatchToProps
)(ItemCommentsDialog);


